import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAllOrganizations } from './thunks';

interface OrganizationState {
  organizations: any[];
  isLoading: boolean;
  error: string | null;
  isOrganizationsFetched: boolean;
}

const initialState: OrganizationState = {
  organizations: [],
  isLoading: false,
  error: null,
  isOrganizationsFetched: false,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    // Synchronous actions
    replaceOrganizationState: (
      state,
      action: PayloadAction<Partial<OrganizationState>>
    ) => {
      return { ...state, ...action.payload };
    },
    setError: (state, action: PayloadAction<{ error: string | null }>) => {
      state.error = action.payload.error;
      state.isLoading = false;
    },
    clearOrganizations: (state) => {
      state.organizations = [];
      state.isOrganizationsFetched = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Handle async thunk states
    builder
      .addCase(fetchAllOrganizations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllOrganizations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizations = action.payload;
        state.isOrganizationsFetched = true;
        state.error = null;
      })
      .addCase(fetchAllOrganizations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch organizations';
        state.isOrganizationsFetched = false;
      });
  },
});

export const organizationActions = organizationSlice.actions;
export default organizationSlice.reducer;
